export function getLastNYears(yearNum) {
    let year = new Date().getFullYear();
    const years = [];

    for (let i = 0; i < yearNum; i++) {
        years.push({
            label: `${year}`,
            value: year
        });
        year = year - 1;
    }

    return years;
}
